export const siteSettings = {
  name: "Helix Trades",
  link: "https://helixtrades.net",
  email: "support@helixtrades.net",
  appLink: "https://app.helixtrades.net",
};
